import { SkipToken } from '@reduxjs/toolkit/dist/query';
import { isNil } from 'lodash';
import { useMemo, useRef } from 'react';
import { accountsService, SubscriptionInfo } from 'services';
import { useConfig } from './useConfig';

const EMPTY_SUBSCRIPTIONS: Record<string, SubscriptionInfo[]> = {};

export function useSubscriptions(userId: string | SkipToken) {
  const { data: subscriptions = EMPTY_SUBSCRIPTIONS } =
    accountsService.useSubscriptionsQuery(userId);

  const currency = useRef('');

  const totalAmount = useMemo(
    () =>
      Object.values(subscriptions)
        .flatMap((subs) => subs)
        .reduce((acc, sub) => {
          let nextAcc = acc;
          currency.current = sub.PurchaseInfo?.Currency;
          nextAcc += sub.Status ? sub.PurchaseInfo?.Price || 0 : 0;
          return nextAcc;
        }, 0),
    [subscriptions]
  );

  const config = useConfig();

  const currencySign =
    config.dictionaries.currencies[currency.current]?.Sign || '';

  return {
    subscriptions,
    subscriptionsCount: Object.keys(subscriptions).length,
    totalAmount,
    totalAmountWithCurrency: [totalAmount, currencySign]
      .filter((v) => !isNil(v))
      .join(' '),
    currency: currencySign
  };
}
